import { useCurrentUserRegions } from "../hooks/useCurrentUserRegions.js";
//#region src/modules/AppWrapper2/components/IsMultiRegion.tsx
function IsMultiRegion({ children }) {
	const { availableRegions } = useCurrentUserRegions();
	if (availableRegions.length > 1) return children;
	return null;
}
//#endregion
export { IsMultiRegion };

//# sourceMappingURL=IsMultiRegion.js.map